import React from "react";
import "./timelines.css";

function Timelines() {
  return (
    <div className="infographic-wrapper">

      <h2 className="info-title">INFOGRAPHIC <span>STEPS</span></h2>

      {/* STEP 1 */}
      <div className="step-row left">
        <div className="step-box">
          <div className="step-inner">
            <p>STEP</p>
            <h1>1</h1>
          </div>
          <div className="step-shadow"></div>
        </div>

        <div className="arrow-line left-arrow"></div>

        <div className="step-text">
          <h3>Lorem ipsum</h3>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
        </div>
      </div>

      {/* STEP 2 */}
      <div className="step-row right">
        <div className="step-box">
          <div className="step-inner">
            <p>STEP</p>
            <h1>2</h1>
          </div>
          <div className="step-shadow"></div>
        </div>

        <div className="arrow-line right-arrow"></div>

        <div className="step-text">
          <h3>Lorem ipsum</h3>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
        </div>
      </div>

      {/* STEP 3 */}
      <div className="step-row left">
        <div className="step-box">
          <div className="step-inner">
            <p>STEP</p>
            <h1>3</h1>
          </div>
          <div className="step-shadow"></div>
        </div>

        <div className="arrow-line left-arrow"></div>

        <div className="step-text">
          <h3>Lorem ipsum</h3>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
        </div>
      </div>

      {/* STEP 4 */}
      <div className="step-row right">
        <div className="step-box">
          <div className="step-inner">
            <p>STEP</p>
            <h1>4</h1>
          </div>
          <div className="step-shadow"></div>
        </div>

        <div className="arrow-line right-arrow"></div>

        <div className="step-text">
          <h3>Lorem ipsum</h3>
          <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</p>
        </div>
      </div>

    </div>
  );
}

export default Timelines;
